import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Accordion } from '@components/Accordion';
import { Points, textSize } from '@styles';
import { useTranslations } from '@libs/translations';

export const Questions = ({ questionData, titleTranslationKey, descriptionTranslationKey, className }) => {
  const translations = useTranslations();

  return (
    <Container className={className}>
      <TitleWrapper>
        <Title>{translations.t(titleTranslationKey)}</Title>
        <Description>{translations.t(descriptionTranslationKey)}</Description>
      </TitleWrapper>
      <QuestionWrapper>
        <Accordion data={questionData} isHtml={true} />
      </QuestionWrapper>
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 80px 16px;
  background-color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    flex-direction: row;
    align-items: start;
    padding-top: 100px;
    padding-bottom: 100px;
    gap: 60px;
  }

  @media ${Points.laptop_wide} {
    padding-top: 120px;
    padding-bottom: 125px;
    gap: 80px;
  }

  @media ${Points.fullhd} {
    padding-top: 160px;
    gap: 90px;
  }
`;

const TitleWrapper = styled.div`
  width: 100%;

  @media ${Points.tablet_landscape} {
    width: 285px;
  }

  @media ${Points.laptop} {
    width: 350px;
  }

  @media ${Points.laptop_wide} {
    width: 360px;
  }

  @media ${Points.fullhd} {
    width: 425px;
  }
`;

const Title = styled.h2`
  ${textSize('block_header')};
  font-weight: 200;
`;

const Description = styled.div`
  margin-top: 10px;
  color: ${Colors.main_gray};
  ${textSize('faq_description')};

  @media ${Points.tablet_landscape} {
    margin-top: 20px;
  }
`;

const QuestionWrapper = styled.div`
  display: block;
  width: 100%;

  @media ${Points.tablet_landscape} {
    width: 623px;
  }

  @media ${Points.laptop} {
    width: 770px;
  }

  @media ${Points.laptop_wide} {
    width: 840px;
  }

  @media ${Points.fullhd} {
    width: 900px;
  }
`;
